import React from "react";
import "../NewsletterConfirmation/style.scss";
import "../../../style/alerts.scss";
import { passValidator } from "../../../utils/formsValidation";
import useChangePasswordForm, { CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_WAITING } from "./useChangePasswordForm";
import { useTranslation } from "react-i18next";
import { LOGIN_PAGE } from "../../routes";
import { useNavigate } from "react-router-dom";
import EAButton from "../shared/Buttons/EAButton";
import EATextField from "../shared/TextField/EATextField";
import EAAlert from "../shared/EAAlert";
import { IoMdArrowRoundForward } from "react-icons/io";
import inputsValidation from "../../../messages/inputValidation";

const ChangePasswordForm: React.FC = () => {
  const { t } = useTranslation();
  const { status, onConfirm, register, handleSubmit, errors } = useChangePasswordForm();
  const navigate = useNavigate();

  const getTitle = () => {
    if (status === CHANGE_PASSWORD_SUCCESS) {
      return "🎉 Hasło zmieniono pomyślnie";
    } else {
      return t("zmiana_hasla");
    }
  };
  return (
    <>
      <div className="change-password-form__container">
        <div className="change-password-form__box">
          <h1 className="text-color-dark text-centered">{getTitle()}</h1>
          {status !== CHANGE_PASSWORD_SUCCESS ? (
            <form onSubmit={handleSubmit(onConfirm)} className="change-password-form__content">
              <EATextField
                label={t("nowe_haslo")}
                type="password"
                name="password"
                fullWidth
                error={!!errors.password}
                helperText={inputsValidation(errors, "password")}
                register={register("password", { ...passValidator(true) })}
              />
              <EATextField
                label={t("potwierdz_nowe_haslo")}
                type="password"
                name="repeatedPassword"
                fullWidth
                error={!!errors.repeatedPassword}
                helperText={inputsValidation(errors, "repeatedPassword")}
                register={register("repeatedPassword", { ...passValidator(true) })}
              />

              {status !== CHANGE_PASSWORD_SUCCESS && status !== CHANGE_PASSWORD_WAITING && (
                <EAAlert message={status} type="error" />
              )}

              <EAButton title="Zmień hasło" onClick={handleSubmit(onConfirm)} fullWidth />
            </form>
          ) : (
            <div className="change-password-form__login-button">
              <EAButton
                title="Zaloguj się"
                onClick={() => navigate(LOGIN_PAGE)}
                fullWidth
                variant="filled"
                endIcon={<IoMdArrowRoundForward />}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChangePasswordForm;
